import { selectComponentDefinitions } from "./groupDefinitions";

export const previewComponents = selectComponentDefinitions([
    "Book Preview",
    "Merch Preview",
    "Change Request",
]);
